module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table3"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year1) + "年")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.yearSet.year2) + "年")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版单位年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("出版单位年利润(税后)总额（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "6"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度销售收入（万元）\n            ")]), _vm._v(" "), _c('td', [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("发行和销售收入\n            ")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales1", $$v)
      },
      expression: "params.firstSales1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales1", $$v)
      },
      expression: "params.secondSales1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出让版权的收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales2", $$v)
      },
      expression: "params.firstSales2"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales2", $$v)
      },
      expression: "params.secondSales2"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("出版活动收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales3", $$v)
      },
      expression: "params.firstSales3"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales3", $$v)
      },
      expression: "params.secondSales3"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("提供内容审校加工等"), _c('br'), _vm._v("各种服务的收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales4", $$v)
      },
      expression: "params.firstSales4"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales4", $$v)
      },
      expression: "params.secondSales4"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他收入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales5", $$v)
      },
      expression: "params.firstSales5"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales5", $$v)
      },
      expression: "params.secondSales5"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSales", $$v)
      },
      expression: "params.firstSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSales", $$v)
      },
      expression: "params.secondSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "9"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度支出（万元）\n            ")]), _vm._v(" "), _c('td', [(_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("出版团队的"), _c('br'), _vm._v("人员成本费用"), _c('br'), _vm._v("（包括工资、福利、奖金等）\n            ")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay1", $$v)
      },
      expression: "params.firstPay1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay1", $$v)
      },
      expression: "params.secondPay1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("房租水电等"), _c('br'), _vm._v("运营成本费用")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay2", $$v)
      },
      expression: "params.firstPay2"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay2", $$v)
      },
      expression: "params.secondPay2"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("获取内容及"), _c('br'), _vm._v("审校加工等"), _c('br'), _vm._v("各种劳务的支出")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay3", $$v)
      },
      expression: "params.firstPay3"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay3", $$v)
      },
      expression: "params.secondPay3"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("印刷压盘"), _c('br'), _vm._v("包装等费用")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay4", $$v)
      },
      expression: "params.firstPay4"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay4", $$v)
      },
      expression: "params.secondPay4"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("新媒体上的投入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay5", $$v)
      },
      expression: "params.firstPay5"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay5),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay5", $$v)
      },
      expression: "params.secondPay5"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("固定资产投入")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay6", $$v)
      },
      expression: "params.firstPay6"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay6),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay6", $$v)
      },
      expression: "params.secondPay6"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("培训支出")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay7),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay7", $$v)
      },
      expression: "params.firstPay7"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay7),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay7", $$v)
      },
      expression: "params.secondPay7"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他支出")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay8),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay8", $$v)
      },
      expression: "params.firstPay8"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay8),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay8", $$v)
      },
      expression: "params.secondPay8"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合计")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPay", $$v)
      },
      expression: "params.firstPay"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPay", $$v)
      },
      expression: "params.secondPay"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年税费（万元）\n              "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指与"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版")]) : _vm._e(), _vm._v("相关的企业所得缴纳税费，含营业税和所得税")])]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTax", $$v)
      },
      expression: "params.firstTax"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTax),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTax", $$v)
      },
      expression: "params.secondTax"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("年度利润（税后）总额（万元）\n            ")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstProfit", $$v)
      },
      expression: "params.firstProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondProfit", $$v)
      },
      expression: "params.secondProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("获得基金类资助（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstFund", $$v)
      },
      expression: "params.firstFund"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondFund),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondFund", $$v)
      },
      expression: "params.secondFund"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("主办主管单位给与的经费支持（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSuperior", $$v)
      },
      expression: "params.firstSuperior"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSuperior),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSuperior", $$v)
      },
      expression: "params.secondSuperior"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("出版品种\n            ")]), _vm._v(" "), _c('td', [_vm._v("载体出版")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbVariety", $$v)
      },
      expression: "params.firstZtcbVariety"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbVariety", $$v)
      },
      expression: "params.secondZtcbVariety"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("信息网络出版")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbVariety", $$v)
      },
      expression: "params.firstWlcbVariety"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbVariety", $$v)
      },
      expression: "params.secondWlcbVariety"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("总计")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstPublicationVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstPublicationVariety", $$v)
      },
      expression: "params.firstPublicationVariety"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondPublicationVariety),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondPublicationVariety", $$v)
      },
      expression: "params.secondPublicationVariety"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("经营情况"), _c('br'), _vm._v("载体出版\n            ")]), _vm._v(" "), _c('td', [_vm._v("销售数量（套/张）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstSalesVolumes", $$v)
      },
      expression: "params.firstSalesVolumes"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondSalesVolumes),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondSalesVolumes", $$v)
      },
      expression: "params.secondSalesVolumes"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbSales", $$v)
      },
      expression: "params.firstZtcbSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbSales", $$v)
      },
      expression: "params.secondZtcbSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbProfit", $$v)
      },
      expression: "params.firstZtcbProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbProfit", $$v)
      },
      expression: "params.secondZtcbProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "5"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("载体出版发行的渠道及占比\n\n              "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("新华书店%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne", $$v)
      },
      expression: "params.firstZtcbDistributionChanne"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne", $$v)
      },
      expression: "params.secondZtcbDistributionChanne"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("馆配商%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne1", $$v)
      },
      expression: "params.firstZtcbDistributionChanne1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne1", $$v)
      },
      expression: "params.secondZtcbDistributionChanne1"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("邮局%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne2", $$v)
      },
      expression: "params.firstZtcbDistributionChanne2"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne2),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne2", $$v)
      },
      expression: "params.secondZtcbDistributionChanne2"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne3", $$v)
      },
      expression: "params.firstZtcbDistributionChanne3"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne3),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne3", $$v)
      },
      expression: "params.secondZtcbDistributionChanne3"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstZtcbDistributionChanne4", $$v)
      },
      expression: "params.firstZtcbDistributionChanne4"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondZtcbDistributionChanne4),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondZtcbDistributionChanne4", $$v)
      },
      expression: "params.secondZtcbDistributionChanne4"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v("经营情况"), _c('br'), _vm._v("\n              信息网络出版\n            ")]), _vm._v(" "), _c('td', [_vm._v("年销售收入（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbSales", $$v)
      },
      expression: "params.firstWlcbSales"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbSales", $$v)
      },
      expression: "params.secondWlcbSales"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("年利润总额（万元）")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbProfit", $$v)
      },
      expression: "params.firstWlcbProfit"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbProfit", $$v)
      },
      expression: "params.secondWlcbProfit"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("音像制品")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子出版物")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("信息网络出版渠道及占比 "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("（请填写%之前的数值）")])]), _vm._v(" "), _c('td', [_vm._v("互联网网络营销平台%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne", $$v)
      },
      expression: "params.firstWlcbDistributionChanne"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne", $$v)
      },
      expression: "params.secondWlcbDistributionChanne"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("自办发行%")]), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstWlcbDistributionChanne1", $$v)
      },
      expression: "params.firstWlcbDistributionChanne1"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondWlcbDistributionChanne1),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondWlcbDistributionChanne1", $$v)
      },
      expression: "params.secondWlcbDistributionChanne1"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea"
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-3：经营情况表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66adc667"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table3.vue
// module id = 1759
// module chunks = 1